import { Routes } from '@angular/router';
import { MainLayoutComponent } from '@app/main-layout/main-layout/main-layout.component';
import { UserLoggedGuard, StatisticsLoaded, RegulationsAccepted, RegulationseNotAccepted } from '@app/privileges';
import { priceCleanup, priceRatesLoaded } from './store/price';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: '',
        children: [
            {
                path: 'login',
                loadChildren: () => import('./login/login.routes').then((m) => m.routes),
            },
            {
                path: '',
                canActivate: [UserLoggedGuard],
                children: [
                    {
                        path: '',
                        component: MainLayoutComponent,
                        canActivate: [RegulationsAccepted],
                        children: [
                            {
                                path: '',
                                canActivate: [StatisticsLoaded],
                                children: [
                                    {
                                        path: '',
                                        redirectTo: 'home',
                                        pathMatch: 'full',
                                    },
                                    {
                                        path: 'dashboard',
                                        loadChildren: () => import('./dashboard/dashboard.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'home',
                                        loadChildren: () => import('./promotions/promotions.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: '',
                                        loadChildren: () => import('./users/users.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: '',
                                        loadChildren: () => import('./facilities/facilities.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'products',
                                        loadChildren: () => import('./products/products.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'profile',
                                        loadChildren: () => import('./profile/profile.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'web',
                                        loadChildren: () => import('./web/web.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'client',
                                        loadChildren: () => import('./client/client.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'orders',
                                        canActivate: [priceRatesLoaded()],
                                        canDeactivate: [priceCleanup()],
                                        loadChildren: () => import('./orders/orders.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'catalog',
                                        loadChildren: () => import('./catalog/catalog.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'reports',
                                        loadChildren: () => import('./reports/reports.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'invoices',
                                        loadChildren: () => import('./invoices/invoices.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'import-csv',
                                        loadChildren: () => import('./import-csv/import-csv.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'assets',
                                        loadChildren: () => import('./import-assets/import-assets.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'exchange-rates',
                                        loadChildren: () => import('./exchange-rates/exchange-rates.routes').then((m) => m.routes),
                                    },
                                    {
                                        path: 'metal-order',
                                        loadChildren: () => import('./metal-order/metal-order.routing').then(({ routes }) => routes),
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'regulations',
                        canActivate: [RegulationseNotAccepted],
                        loadChildren: () => import('./regulations/regulations.routes').then((m) => m.routes),
                    },
                ],
            },
            {
                path: 'logout',
                loadChildren: () => import('./logout/logout.routes').then((m) => m.routes),
            },
        ],
    },
    {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
];
